import { render, staticRenderFns } from "./AlertBody.vue?vue&type=template&id=1d1671db&scoped=true&"
import script from "./AlertBody.vue?vue&type=script&lang=ts&"
export * from "./AlertBody.vue?vue&type=script&lang=ts&"
import style0 from "./AlertBody.vue?vue&type=style&index=0&id=1d1671db&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1671db",
  null
  
)

export default component.exports